// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".viewer-controls[data-v-22ba1d94]{background-color:rgba(0,0,0,.7);bottom:0;left:0;padding:.875rem 1rem;right:0;z-index:1}.viewer-controls .divider[data-v-22ba1d94]{border-color:#767676}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
